import type { FieldMode } from '@workbuddy/ui/v2/surface.engine/core/contracts/field.binding';

// Invoice/bill customerReference, quote/SO customerRef, PO reference. Same meta slot on the shared host.
const REFERENCE_BINDS = new Set(['customerReference', 'customerRef', 'reference']);

export function isFinancialDocumentReferenceBind(bind: string): boolean {

  return REFERENCE_BINDS.has(bind);
}

/**
 * Full reference for the readonly tooltip. Edit mode scrolls the input, so it gets nothing.
 * Empty stays empty — a tooltip with no text is a blank popup (WBS-11328).
 */
export function financialDocumentReferenceTooltip(mode: FieldMode, bind: string, value: unknown): string | null {

  if (mode !== 'read' || !isFinancialDocumentReferenceBind(bind)) return null;
  if (typeof value !== 'string') return null;
  const text = value.trim();
  return text.length > 0 ? text : null;
}
